import React, { useEffect, useRef, useState } from "react"
import _ from "lodash"
import Isvg from "react-inlinesvg"
// PR
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
// Components
import CarouselAutomation from "components/carousel-automation"
import { field as _field } from "components/table/lib/column-field"
import SearchHeader from "components/table/search-header"
import {
  TableAutomation
} from "components/table/table-automation"
import { CheckboxInput, DropdownEdit } from "components/table/inputs"
import { InputText_s } from "styles/input-styles"
import { DropdownField } from "components/table/display"
// Data
import { statesAndProvinces } from "data/lib/statesAndProvinces"
import { alphanum } from "components/table/lib/sort"
// Styles
import { AssetSelectionTable_s } from "components/asset-management/portfolios/portfolio-styles"
// Icons
import { CommercialIcon, HospitalityIcon, MFRentIcon } from 'images/icons/sidebar'
import portfolioAssetService from "data/portfolio-asset"

type ContextRow = {
  assetid: number
  code: string
  sortorder: number
  systeminput?: string
}

const tableId = "assetSelectionTable"

const AssetSelectionDetailed = (props: {currentPortfolio:object|null, assets: object[], portfolioAssets: object[]|null}) => {
  const usePrevious = (value) =>{
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const [selected, setSelected] = useState<object[]|null>(props.portfolioAssets ? props.portfolioAssets.map(portfolioAsset => _.find(props.assets, {assetid: portfolioAsset['assetid']})) : null);
  const [currentPortfolio, setCurrentPortfolio] = useState<object>(props.currentPortfolio!);
  const [portfolioAssets, setPortfolioAssets] = useState<object[]|null>(props.portfolioAssets);
  const [filteredData, setFilteredData] = useState<object[]|null>(props.assets);
  const [searchFilter, setSearchFilter] = useState<string>("")
  const [deleteConfirmation, setDeleteConfirmation] = useState<JSX.Element | null>(null)
  const prevSearch = usePrevious(searchFilter);
  const [automationActive, setAutomationActive] = useState<boolean>(false);
  const [tableAutomationActive, setTableAutomationActive] = useState<boolean>(true);
  const [showSelected, setShowSelected] = useState<string>(props.portfolioAssets && props.portfolioAssets.length > 0 ? 'Selected' : 'All')
  const [selectedPropertyType, setSelectedPropertyType] = useState<string>("All")
  const [activeFilter, setActiveFilter] = useState<string>("Active")
  const [codeFilter, setCodeFilter] = useState<string>("");
  const [nameFilter, setNameFilter] = useState<string>("");
  const [countryFilter, setCountryFilter] = useState<string>("All");
  const [cityFilter, setCityFilter] = useState<string>("");
  const [stateFilter, setStateFilter] = useState<string>("");
  const [addressFilter, setAddressFilter] = useState<string>("");
  const [postalCodeFilter, setPostalCodeFilter] = useState<string>("");
  const tableRef = useRef() as React.MutableRefObject<DataTable>
  const field = _field('assetList')

  useEffect(() => {
    if (prevSearch !== "" && searchFilter === "") _.invoke(tableRef, 'current.filter', '', 'contains');
    else if (searchFilter !== "") _.invoke(tableRef, 'current.filter', searchFilter, 'contains');
    else return
  }, [searchFilter])

  useEffect(() => {
    setTableAutomationActive(true)
    setAutomationActive(false)
  }, [currentPortfolio])

  useEffect(() => {
    const nextPortfolioAssets = props.portfolioAssets?.map(portfolioAsset => _.find(props.assets, {assetid: portfolioAsset['assetid']})) || null
    setSelected(nextPortfolioAssets);
  }, [props.portfolioAssets])

  useEffect(() => {
    filterData();
  }, [props.portfolioAssets, selectedPropertyType, codeFilter, nameFilter, activeFilter, addressFilter, cityFilter, stateFilter, countryFilter, postalCodeFilter])

  function filterData():void {
    let nextData = _.cloneDeep(props.assets);

    if (selectedPropertyType !== 'All') nextData = nextData.filter(item => _.get(item, 'propertytype') === selectedPropertyType)
    if (countryFilter !== 'All') nextData = nextData.filter(item => _.get(item, 'country') === countryFilter)

    if (activeFilter === 'Active'){
      nextData = nextData.filter(item => _.get(item, 'active') === true)
    } else if (activeFilter !== 'All') {
      nextData = nextData.filter(item => _.get(item, 'active') === false)
    }

    if (!_.isNil(codeFilter) && codeFilter !== "") nextData = nextData.filter(item => _.get(item, 'code')?.toLowerCase().includes(codeFilter.toLowerCase()))
    if (!_.isNil(nameFilter) && nameFilter !== "") nextData = nextData.filter(item => _.get(item, 'name')?.toLowerCase().includes(nameFilter.toLowerCase()))
    if (!_.isNil(addressFilter) && addressFilter !== "") nextData = nextData.filter(item => _.get(item, 'address')?.toLowerCase().includes(addressFilter.toLowerCase()))
    if (!_.isNil(cityFilter) && cityFilter !== "") nextData = nextData.filter(item => _.get(item, 'city')?.toLowerCase().includes(cityFilter.toLowerCase()))
    if (!_.isNil(stateFilter) && stateFilter !== "") nextData = nextData.filter(item => _.get(item, 'state') && _.find(statesAndProvinces, { value: _.get(item, 'state')})['label'].toLowerCase().includes(stateFilter.toLowerCase()))
    if (!_.isNil(postalCodeFilter) && postalCodeFilter !== "") nextData = nextData.filter(item => _.get(item, 'postalcode')?.toLowerCase().includes(postalCodeFilter.toLowerCase()))

    setFilteredData(nextData)
  }

  function handleSelection(val):void {
    setSelected(val);
    const portfolioid = currentPortfolio['portfolioid']

    if (!_.isNil(val)){
      if (props.assets.length === val.length){
        // All are checked
        _.forEach(val, (asset) => {
          if (!_.find(selected, {assetid: asset['assetid']})) portfolioAssetService.create(portfolioid, asset['assetid'])
        })
      } else if (selected?.length === 0 && val.length > 0){
        // Checked first
        portfolioAssetService.create(portfolioid, val[0]['assetid'])
      } else if (val.length === 0 && selected?.length !== 0){
        // Last one unchecked
        _.forEach(props.portfolioAssets, (portfolioAsset) => portfolioAssetService.deleteOne(portfolioid, portfolioAsset['assetid']))
      } else if (!_.isNil(selected) && selected!.length > val.length){
        // Unchecked
        _.forEach(selected, (portfolioAsset) => {
          if (!_.find(val, {assetid: portfolioAsset['assetid']})) portfolioAssetService.deleteOne(portfolioid, portfolioAsset['assetid'])
        });
      } else {
        _.forEach(val, (asset) => {
          // Checked
          if (!_.find(selected, {assetid: asset['assetid']})) portfolioAssetService.create(portfolioid, asset['assetid']);
        })
      }
    }
  }

  const rowClassName = (rowData) => {
    return {'' : rowData}
  }

  return (
    <div>
      <SearchHeader setSearchFilter={setSearchFilter} />
      <AssetSelectionTable_s id="assetSelectionTable-scrollable-container">
        { filteredData && <DataTable
          globalFilter={searchFilter}
          id='assetSelectionTable'
          ref={tableRef}
          value={showSelected === 'Selected' ? selected?.filter(item => { return _.find(filteredData, (i) => _.get(i, "assetid") === _.get(item, "assetid")) }).sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))) : filteredData}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          scrollable={true}
          frozenWidth="525px"
          paginatorPosition="bottom"
          rowClassName={rowClassName}
          stateStorage="custom"
          selection={selected}
          onSelectionChange={(e) => handleSelection(e.value)}
          customSaveState={state => localStorage.setItem("primereact-table-preferences", JSON.stringify({rows: state.rows}))}
          customRestoreState={() => JSON.parse(localStorage.getItem("primereact-table-preferences")!)}
        >
          <Column header="Display" selectionMode="multiple" frozen={true} style={{minWidth: '150px'}} className="selection-column"
            filter
            filterElement={
              <DropdownEdit
                field="showSelected"
                rowData={{showSelected}}
                options={["All", "Selected"]}
                persist={(val) => setShowSelected(val)}
              />
            }
          />
          <Column frozen={true} style={{minWidth: "125px"}} className="p-editable-column property-type-column"
            filter
            sortable
            header="Property Type"
            body={(rowData, props) => <Isvg src={_.get(rowData, "propertytype") === 'Multifamily' ? MFRentIcon : _.get(rowData, "propertytype") === 'Hospitality' ? HospitalityIcon : CommercialIcon} />}
            filterElement={
              <DropdownEdit
                field="selectedPropertyType"
                rowData={{selectedPropertyType}}
                options={["All", "Commercial", "Multifamily", "Hospitality"]}
                persist={(val) => setSelectedPropertyType(val)}
              />
            }
          />
          <Column frozen={true} style={{minWidth: "250px"}} className="p-editable-column"
            filter
            sortable
            header="Code"
            {...field('code')}
            filterElement={
              <InputText_s value={codeFilter} onChange={(e) => setCodeFilter(e.target.value)} />
            }
          />
          <Column style={{minWidth: "250px", maxWidth: "250px"}} className="p-editable-column asset-name"
            filter
            sortable
            header="Name"
            {...field('name')}
            filterElement={
              <InputText_s value={nameFilter} onChange={(e) => setNameFilter(e.target.value)} />
            }
          />
          <Column style={{minWidth: "100px"}} className="p-editable-column"
            filter
            sortable
            header="Active"
            {...field('active', (rowData, props) => CheckboxInput({rowData, ...props}))}
            filterElement={
              <DropdownEdit
                field="activeFilter"
                rowData={{activeFilter}}
                options={["All", "Active", "Inactive"]}
                persist={(val) => setActiveFilter(val)}
              />
            }
          />
          <Column style={{minWidth: "100px"}} className="p-editable-column"
            filter
            sortable
            header="Country"
            {...field('country', (rowData, props) => DropdownField({options: [{value: 'US', label: 'US'},{value: 'CA', label: 'Canada'}], rowData, ...props}))}
            filterElement={
              <DropdownEdit
                field="countryFilter"
                rowData={{countryFilter}}
                options={["All", "US", "CA"]}
                persist={(val) => setCountryFilter(val)}
              />
            }
          />
          <Column style={{minWidth: "250px"}} className="p-editable-column"
            filter
            sortable
            header="Address"
            {...field('address')}
            filterElement={
              <InputText_s value={addressFilter} onChange={(e) => setAddressFilter(e.target.value)} />
            }
          />
          <Column style={{minWidth: "180px"}} className="p-editable-column"
            filter
            sortable
            header="City"
            {...field('city')}
            filterElement={
              <InputText_s value={cityFilter} onChange={(e) => setCityFilter(e.target.value)} />
            }
          />
          <Column style={{minWidth: "225px"}} className="p-editable-column"
            filter
            sortable
            header="State"
            {...field('state', (rowData, props) => DropdownField({options: statesAndProvinces, rowData, ...props}))}
            filterElement={
              <InputText_s value={stateFilter} onChange={(e) => setStateFilter(e.target.value)} />
            }
          />
          <Column style={{minWidth: "130px"}} className="p-editable-column"
            filter
            sortable
            header="Postal Code"
            {...field('postalcode')}
            filterElement={
              <InputText_s value={postalCodeFilter} onChange={(e) => setPostalCodeFilter(e.target.value)} />
            }
          />
        </DataTable> }
        { deleteConfirmation }
        { filteredData && filteredData.length
          ? <div>
              <CarouselAutomation outsideTable={true} automationActive={automationActive} editableFilters={true} includeSearchBar={true} tabOut={() => { setAutomationActive(false); setTableAutomationActive(true) }} />
              <TableAutomation tableId="assetSelectionTable" automationActive={tableAutomationActive} shiftTabOut={() => setTableAutomationActive(false)}/>
            </div>
          : null
        }
      </AssetSelectionTable_s>
    </div>
  )
}

export default AssetSelectionDetailed
